import { render, staticRenderFns } from "./windowLottery.vue?vue&type=template&id=7275a6a0&scoped=true"
import script from "./windowLottery.vue?vue&type=script&lang=js"
export * from "./windowLottery.vue?vue&type=script&lang=js"
import style0 from "./windowLottery.vue?vue&type=style&index=0&id=7275a6a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7275a6a0",
  null
  
)

export default component.exports